import { LocalizedTextTag } from '@mews-commander/ui';
import { createHandler } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { TagVariant } from '@optimus-web/core';
import { BillClassification } from '../constants';

export const getTagVariantFromBillClassification = createHandler<BillClassification, TagVariant>(
    {
        [BillClassification.Owned]: 'info',
        [BillClassification.Associated]: 'basicSubtle',
    },
    'basicBold'
);

const getTextBillClassification = createHandler<BillClassification, Mews.TextKey>({
    [BillClassification.Owned]: TextKey.Owned,
    [BillClassification.Associated]: TextKey.Associated,
});

interface BillClassificationTagProps {
    billClassification: BillClassification;
}

export const BillClassificationTag = ({ billClassification }: BillClassificationTagProps) => {
    const textKey = getTextBillClassification(billClassification);
    const variant = getTagVariantFromBillClassification(billClassification);
    return <LocalizedTextTag textKey={textKey} variant={variant} />;
};
